import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Header from './Header';
import itemImg from '../assets/images/account-offer-made/card1.png';
import buyerIcon from '../assets/images/user-profile/profile-picture.png';
import user1 from '../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png';
import user2 from '../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-2.png';
import user3 from '../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-3.png';
import user4 from '../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-4.png';
import droppedIcon from '../assets/images/Artwork-Specific-Edition-Page-Auction/dropped-icon.svg';
import purchasedIcon from '../assets/images/Artwork-Specific-Edition-Page-Auction/purchased-icon.svg';
import listedIcon from '../assets/images/Artwork-Specific-Edition-Page-Auction/listed-icon.svg';
import initialDrop from '../assets/images/Artwork-Specific-Edition-Page-Auction/initial-drop-date.svg';
import averageResalePrice from '../assets/images/Artwork-Specific-Edition-Page-Auction/average-resale-price.svg';
import highestBid from '../assets/images/Artwork-Specific-Edition-Page-Auction/highest-bid-all-editions.svg';
import lowestAsk from '../assets/images/Artwork-Specific-Edition-Page-Auction/lowest-ask-all-editions.svg';
import marketplaceSales from '../assets/images/Artwork-Specific-Edition-Page-Auction/marketplace-sales.svg';
import marketplaceVolume from '../assets/images/Artwork-Specific-Edition-Page-Auction/marketplace-volume.svg';
import priceChange from '../assets/images/Artwork-Specific-Edition-Page-Auction/price-change-since-drop.svg';
import purchasePrice from '../assets/images/Artwork-Specific-Edition-Page-Auction/purchase-price-range.svg';

class OfferMadeItemDetails extends Component {
    render() {
        return (
            <div className="main-wrapper">
                <Header />
                {/* Header area end */}

                {/* Item details area start */}
                <div className="container mb-3">
                    <div className="row collection justify-content-between">
                        <div className="col-md-6 upcoming-collection">
                            <img src={itemImg} alt="" width="100%" />
                            <p><Link to="#">VIEW COLLECTION</Link>
                                <small className="pull-right">Contract Address</small>
                            </p>
                            <small className="pull-right">0xbfb69918f12eed843c67058b2ee9059f1440133e</small>
                        </div>

                        <div className="col-md-5 mt-auto mb-4 upcoming">
                            <h3>Nois7</h3>
                            <h1>Solar Eclipse / OE #11
                                <span>
                                    Owned by <Link to="/UserProfileBuyer">NFTYbuyer1 </Link>
                                    <img src={buyerIcon} alt="buyer" />
                                </span>
                            </h1>
                            <hr />
                            <p>DREAMING WITH OPEN EYES Open Editions
                                <span>Edition of 34</span>
                            </p>
                            <p>In the distance a long shadow forms, moving ever closer to them both. They look at the sun and see how the full moon moves across the sun. The birds fall silent and the animals return to their nests. Around the darkened sun, Sam and Ben can see the brightest planets. As the moon moves slowly beyond the sun and the warmth returns, the next adventure awaits.</p>
                            <h2>$499.00
                                <span>$13,000.00</span>
                            </h2>
                            <h5>Original Listing
                                <span>Offered You</span>
                            </h5>
                            <h2>$8,500.00
                                <span className="black">1d 23h 6m</span>
                            </h2>
                            <h5>You Purchased For
                                <span className="black">Offer Expires</span>
                            </h5>
                            <button type="button">CANCEL offer</button>
                        </div>
                    </div>
                </div>
                {/* Item details area end */}

                {/* Edition history and stats area start */}
                <div className="container mb-5">
                    <div className="row">
                        {/* Edition history area start */}
                        <div className="col-md-4 history-area">
                            <h1>Edition History</h1>
                            <div className="row edition-history">
                                <div className="image">
                                    <img src={user3} alt="" />
                                    <img src={listedIcon} alt="" />
                                </div>
                                <div className="text">
                                    <p>Listed for $8,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    <img src={user4} alt="" />
                                    <img src={purchasedIcon} alt="" />
                                    <img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>Purchased for $8,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1h ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    <img src={user4} alt="" />
                                    <img src={listedIcon} alt="" />
                                </div>
                                <div className="text">
                                    <p>Listed for $3,333.33</p>
                                </div>
                                <div className="time">
                                    <p>15h ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    <img src={user1} alt="" />
                                    <img src={purchasedIcon} alt="" />
                                    <img src={user4} alt="" />
                                </div>
                                <div className="text">
                                    <p>Purchased for $6,000.00</p>
                                </div>
                                <div className="time">
                                    <p>20d ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    <img src={user2} alt="" />
                                    <img src={droppedIcon} alt="" />
                                    <img src={user1} alt="" />
                                </div>
                                <div className="text">
                                    <p>Dropped for $6,000.00</p>
                                </div>
                                <div className="time">
                                    <p>Feb 20</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <h1 className="stats-heading">Stats</h1>
                            <div className="row justify-content-between">
                                <div className="col-md-3 stats-area">
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={initialDrop} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>2/20/21</h4>
                                            <p>Initial Drop</p>
                                        </div>
                                    </div>
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={priceChange} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>+120%</h4>
                                            <p>Price Premium</p>
                                            <span>(Over Initial drop price)</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 stats-area">
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={marketplaceSales} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>200</h4>
                                            <p>Marketplace Sales</p>
                                        </div>
                                    </div>
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={purchasePrice} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>$2k-$30k</h4>
                                            <p>Lifespan Range</p>
                                            <span>(Low-High For All Transactions)</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 stats-area">
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={averageResalePrice} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>$12,345.00</h4>
                                            <p>Average Resale Price</p>
                                        </div>
                                    </div>
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={marketplaceVolume} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>$88,888.88</h4>
                                            <p>Marketplace Volume</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 text-center stats-area">
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={highestBid} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>$17,000.00</h4>
                                            <p>Highest Bid - All Editions</p>
                                        </div>
                                    </div>
                                    <div className="row justify-content-initial">
                                        <div>
                                            <img src={lowestAsk} alt="" />
                                        </div>
                                        <div className="stats-text">
                                            <h4>$7,000.00</h4>
                                            <p>Lowest Ask - All Editions</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Edition history area end */}
                    </div>
                </div>
                {/* Edition history and stats area end */}
            </div >
        )
    }
};

export default OfferMadeItemDetails;